/* eslint-disable no-param-reassign */
// this is what @reduxjs/toolkit expects
import {
  createAsyncThunk,
  createReducer,
  createSelector,
} from '@reduxjs/toolkit'
import { redFunnelAPI } from '../api/api'

const initialState = {
  vehicles: {
    loading: false,
    data: null,
    error: null,
  },
  fares: {
    loading: false,
    data: null,
    error: null,
  },
  vessels: {
    loading: false,
    data: null,
    error: null,
  },
  sundries: {
    loading: false,
    data: null,
    error: null,
  },
}

export const fetchFerryVehicles = createAsyncThunk(
  'ferryContent/getVehicles',
  () => redFunnelAPI.getFerryVehicles(),
)

export const fetchFerryFaresContent = createAsyncThunk(
  'ferryContent/getFares',
  () => {
    return redFunnelAPI.getFerryFares().then(res => {
      const fares = res?.data?.data?.ferryFares || []
      return fares.reduce(
        (obj, fare) => ({
          ...obj,
          [fare.id]: fare,
        }),
        {},
      )
    })
  },
)

export const fetchVessels = createAsyncThunk('ferryContent/getVessels', () =>
  redFunnelAPI.getVessels(),
)

export const fetchSundries = createAsyncThunk('ferryContent/getSundries', () =>
  redFunnelAPI.getAvailableSundries(),
)

export const ferryContentReducer = createReducer(initialState, builder => {
  builder
    .addCase(fetchFerryVehicles.pending, state => {
      state.vehicles.loading = true
    })
    .addCase(fetchFerryVehicles.fulfilled, (state, action) => {
      state.vehicles.loading = false
      state.vehicles.data = action.payload
    })
    .addCase(fetchFerryVehicles.rejected, (state, action) => {
      state.vehicles.loading = false
      state.vehicles.error =
        action.error?.response?.data?.['hydra:description'] ||
        action.error?.message ||
        'unable to fetch ferry vehicles'
    })
    .addCase(fetchFerryFaresContent.pending, state => {
      state.fares.loading = true
    })
    .addCase(fetchFerryFaresContent.fulfilled, (state, action) => {
      state.fares.loading = false
      state.fares.data = action.payload
    })
    .addCase(fetchFerryFaresContent.rejected, (state, action) => {
      state.fares.loading = false
      state.fares.error =
        action.error?.response?.data?.['hydra:description'] ||
        action.error?.message ||
        'unable to fetch fare details'
    })
    .addCase(fetchVessels.pending, state => {
      state.vessels.loading = true
    })
    .addCase(fetchVessels.fulfilled, (state, action) => {
      state.vessels.loading = false
      state.vessels.data = action.payload
    })
    .addCase(fetchVessels.rejected, (state, action) => {
      state.vessels.loading = false
      state.vessels.error =
        action.error?.response?.data?.['hydra:description'] ||
        action.error?.message ||
        'unable to fetch fare details'
    })
    .addCase(fetchSundries.pending, state => {
      state.sundries.loading = true
    })
    .addCase(fetchSundries.fulfilled, (state, action) => {
      state.sundries.loading = false
      state.sundries.data = action.payload
    })
    .addCase(fetchSundries.rejected, (state, action) => {
      state.sundries.loading = false
      state.sundries.error =
        action.error?.response?.data?.['hydra:description'] ||
        action.error?.message ||
        'unable to fetch fare details'
    })
})
export const selectContentState = state => state.ferryContent

export const selectFerryVehicleState = createSelector(
  selectContentState,
  contentState => contentState.vehicles,
)
export const selectFerryFareState = createSelector(
  selectContentState,
  contentState => contentState.fares,
)

export const selectVesselsState = createSelector(
  selectContentState,
  contentState => contentState.vessels,
)
export const selectSundriesState = createSelector(
  selectContentState,
  contentState => contentState.sundries,
)
